'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');
var FormControl = require('react-bootstrap').FormControl;
var PropTypes = require('prop-types');
var HourInput = require('./HourInput');
var MinuteInput = require('./MinuteInput');
var ReactIntl = require('react-intl');

var TimePicker = function (_React$Component) {
  _inherits(TimePicker, _React$Component);

  function TimePicker(props) {
    _classCallCheck(this, TimePicker);

    var _this = _possibleConstructorReturn(this, (TimePicker.__proto__ || Object.getPrototypeOf(TimePicker)).call(this, props));

    _this.listTimeOptions = _this.listTimeOptions.bind(_this);
    _this.generateFormattedTime = _this.generateFormattedTime.bind(_this);
    _this.generateDateAtTime = _this.generateDateAtTime.bind(_this);
    _this.generateHours = _this.generateHours.bind(_this);
    _this.generateMinutes = _this.generateMinutes.bind(_this);
    _this.generateTimeRange = _this.generateTimeRange.bind(_this);
    _this.defaultValueFromProps = _this.defaultValueFromProps.bind(_this);
    _this.changeCombinedTime = _this.changeCombinedTime.bind(_this);
    _this.changeHours = _this.changeHours.bind(_this);
    _this.changeMinutes = _this.changeMinutes.bind(_this);
    return _this;
  }

  _createClass(TimePicker, [{
    key: 'listTimeOptions',
    value: function listTimeOptions() {
      var self = this;

      return this.generateTimeRange().map(function (unformattedTime) {
        var formattedTime = self.generateFormattedTime(unformattedTime);

        return {
          key: unformattedTime,
          value: formattedTime,
          date: self.generateDateAtTime(formattedTime)
        };
      });
    }
  }, {
    key: 'generateFormattedTime',
    value: function generateFormattedTime(unformattedTime) {
      var formattedTime = '' + unformattedTime;

      while (formattedTime.length < 4) {
        formattedTime = '0' + formattedTime;
      }

      return formattedTime.replace(/(.{2})(.{2})/, '$1:$2');
    }
  }, {
    key: 'generateDateAtTime',
    value: function generateDateAtTime(formattedTime) {
      var hoursMins = formattedTime.split(':');
      var newDate = new Date(this.props.value || new Date());
      if (!this.props.seperateHourMins) newDate.setHours(hoursMins[0], hoursMins[1], 0, 0);
      return newDate;
    }
  }, {
    key: 'generateHours',
    value: function generateHours() {
      var hours = [];

      for (var hour = 0; hour < 24; hour++) {
        if (hour < 10) {
          hours.push('0' + hour);
        } else {
          hours.push(hour.toString());
        }
      }
      return hours;
    }
  }, {
    key: 'generateMinutes',
    value: function generateMinutes() {
      var minutes = [];

      for (var minute = 0; minute <= 60 - this.props.step; minute += this.props.step) {
        if (minute < 10) {
          minutes.push('0' + minute);
        } else {
          minutes.push(minute.toString());
        }
      }

      return minutes;
    }
  }, {
    key: 'generateTimeRange',
    value: function generateTimeRange() {
      var times = [];

      var start = parseInt(this.props.start, 10);
      var end = parseInt(this.props.end, 10);
      var step = parseInt(this.props.step, 10);

      for (var i = start; i < end; i += step) {
        var minutes = i % 100;

        if (minutes > 59) {
          i -= minutes;
          i += 100;
        }

        times.push(i);
      }

      return times;
    }
  }, {
    key: 'defaultValueFromProps',
    value: function defaultValueFromProps() {
      if (!this.props.value) return undefined;

      return this.generateFormattedTime(this.props.value.getHours() * 100 + this.props.value.getMinutes());
    }
  }, {
    key: 'changeCombinedTime',
    value: function changeCombinedTime(e) {
      if (this.props.onChange) {
        var hourMins = e.target.value.split(':');
        this.props.onChange({
          hours: hourMins[0],
          minutes: hourMins[1]
        });
      }
    }
  }, {
    key: 'changeHours',
    value: function changeHours(e) {
      this.props.onChange({
        hours: e.target.value,
        minutes: this.props.time.minutes
      });
    }
  }, {
    key: 'changeMinutes',
    value: function changeMinutes(e) {
      this.props.onChange({
        hours: this.props.time.hours,
        minutes: e.target.value
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var timeInput;

      if (this.props.seperateHourMins) {
        timeInput = React.createElement(
          'div',
          { className: 'row' },
          React.createElement(HourInput, {
            id: this.props.id,
            className: this.props.className,
            value: this.props.time.hours,
            name: 'hours',
            onChange: this.changeHours,
            options: this.generateHours() }),
          React.createElement(MinuteInput, {
            id: this.props.id,
            className: this.props.className,
            value: this.props.time.minutes,
            name: 'minutes',
            onChange: this.changeMinutes,
            options: this.generateMinutes() })
        );
      } else {
        timeInput = React.createElement(
          FormControl,
          {
            componentClass: 'select',
            placeholder: 'select',
            value: this.defaultValueFromProps(),
            name: this.props.name,
            className: this.props.className,
            label: this.props.label,
            onChange: this.changeCombinedTime,
            id: this.props.id },
          this.listTimeOptions().map(function (timeData) {
            return React.createElement(
              ReactIntl.FormattedTime,
              _extends({ key: timeData.key, value: timeData.date }, _this2.props.formats.time.short),
              function (time) {
                return React.createElement(
                  'option',
                  { value: timeData.value },
                  time
                );
              }
            );
          })
        );
      }

      return React.createElement(
        ReactIntl.IntlProvider,
        { locale: this.props.locale },
        React.createElement(
          'div',
          null,
          timeInput
        )
      );
    }
  }]);

  return TimePicker;
}(React.Component);

TimePicker.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.instanceOf(Date),
  start: PropTypes.number,
  end: PropTypes.number,
  time: PropTypes.shape({
    hours: PropTypes.string,
    minutes: PropTypes.string
  }),
  step: PropTypes.number,
  locale: PropTypes.string,
  onChange: PropTypes.func,
  seperateHourMins: PropTypes.bool,
  formats: PropTypes.shape({
    time: PropTypes.shape({
      short: PropTypes.object
    })
  })
};

TimePicker.defaultProps = {
  className: 'input-sm',
  label: 'Time',
  name: 'Time',
  // 00:30, 0030 is octal literal 24 & disallowed in strict mode.
  start: 30,
  end: 2359,
  step: 30,
  locale: 'en-GB',
  seperateHourMins: false,
  formats: {
    time: {
      short: {
        hour: '2-digit',
        minute: '2-digit'
      }
    }
  }
};

module.exports = TimePicker;

